import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { content } from '../utils/data';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import Button from '@mui/material/Button';
import SiteModal from './siteCreationModal';
import File from '../assests/file.png';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const SearchBar = ({ onChange, value }) => {
  return (
    <>
      <TextField
        label="Search"
        placeholder="Search by name, location, etc.."
        variant="outlined"
        onChange={onChange}
        size="small"
        value={value}
        sx={{ width: '300px' }}
      />

    </>
  )
}

export const Field = ({
  label,
  value,
  onChange,
  disabled,
  onBlur,
  readOnly = false,  // ✅ Add this
  width = '550px',
}) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      sx={{ width }}
      disabled={disabled}
      type="text"
      inputProps={{
        readOnly,  // ✅ This is the correct way to apply readOnly in MUI
      }}
    />
  );
};

export const LoginButton = ({ size = 'large', onClick, disabled, children, radius = 'lg' }) => {
  if (size === 'large')
    return (
      <button
        className={`rounded-lg bg-krtrima-blue text-white h-[40px] w-[121px] text-lg`}
        onClick={onClick}
      >
        {children}
      </button>
    );
}

export const DropDown = ({
  title,
  placeholder,
  responseData,
  labelKey,
  valueKey,
  value,
  onChange,  disabled = false,   // <-- add only this
  sx = {}
}) => {

  return (
    <Box
      component="form"
      sx={{
        '& .MuiTextField-root': {
          width: '180px',
        },
        '& .MuiInputBase-root': {
          padding: 0,
          height: '40px', // Reduced height
        },
        ...sx,
      }}
      noValidate
      autoComplete="off"
    >
      <TextField
        id="outlined-select-currency"
        select
        label={title}
        placeholder={placeholder}
        onChange={onChange}
        value={value || ""}
        size="small"
        fullWidth
        disabled={disabled} 
      >
        {console.log("Rendering Dropdown:", title, responseData)}
        {responseData?.length ? (
          responseData.map((item) => (
            <MenuItem
              key={item[valueKey]}
              value={item[valueKey]}
            >
              {item[labelKey]}
            </MenuItem>
          ))
        ) : (
          <MenuItem value="">No options available</MenuItem>
        )}
      </TextField>
    </Box>
  );
};

export const NewSiteButton = ({ Name, handleOpen }) => {

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          backgroundColor: '#1381B5',
          '&:hover': { backgroundColor: '#0f6c99' },
          // width: "95px",
          height: '36px',
          fontSize: '10px',
          whiteSpace: 'nowrap', // prevents text wrapping
        }}
      >
        {Name}
      </Button>
    </>
  );
};

export const Submit = ({ Name, onSubmit }) => {

  return (
    <>
      <Button
        variant="contained"
        onClick={onSubmit}
        sx={{
          backgroundColor: '#1381B5',
          '&:hover': { backgroundColor: '#0f6c99' },
          width: "82px",
          height: '36px',
          fontSize: '10px'
        }}
      >
        {Name}
      </Button>
    </>
  );
};

export const Cancel = ({ Name, onClose }) => {

  return (
    <>
      <Button
        variant="text"
        onClick={onClose}
        sx={{
          color: 'gray', // or a specific hex like '#6e6e6e'
          backgroundColor: 'transparent',
          width: '82px',
          height: '36px',
          fontSize: '10px',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: 'transparent', // prevent hover background
            color: 'darkgray', // optional hover color
          },
        }}
      >
        {Name}
      </Button>
    </>
  );
};

export const Card = ({ label, onClick }) => {
  return (
    <>

      <div className="w-[228px] h-[184px] border ">
        <div className="text-lg font-bold mb-2 px-2">{label}</div>
        <div className='flex flex-col items-center justify-center'>
          <img src={File} alt={`Uploaded file ${label}`} className="max-w-full max-h-full object-contain" onClick={onClick} />
        </div>
      </div>


    </>
  )
}

export const DatePickerField = ({ label, value, onChange, sx }) => {
  return (
    <TextField
      label={label || "Select Date"}
      type="date"
      value={value}
      onChange={onChange}
      InputLabelProps={{
        shrink: true,
      }}
      sx={sx}
      fullWidth
    />
  );
};

export const YearPicker = ({ label, selected, onChange }) => {
  return (
    <div>
      <label>{label}</label><br />
      <DatePicker
        selected={selected ? new Date(selected, 0, 1) : null} // Ensure selected is a valid Date object
        onChange={(date) => onChange(date.getFullYear())} // Get the year
        showYearPicker
        dateFormat="yyyy"
        placeholderText="Select Year"
        style={{ width: '530px' }}
      />
    </div>
  );
};
